import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/dr_font/iconfont'
import './assets/kb_font/iconfont'

import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/font/iconfont'
import './assets/iqc_font/iconfont'
import './assets/font_scrap/iconfont' // 废钢判级icon

import './components/index.js' // 全局基础组件注入
import { FloatAdd, FloatSub, FloatMul, FloatDiv } from '@/utils' // 浮点运算加减乘除
import { nativeBridgeCall, nativeBridgeInit } from '@/utils/nativeBridge'

import api from './api'

Vue.prototype.$NativeBridgeCall = nativeBridgeCall
Vue.prototype.$NativeBridgeInit = nativeBridgeInit
Vue.prototype.FloatAdd = FloatAdd //  浮点运算加
Vue.prototype.FloatSub = FloatSub //  浮点运算减
Vue.prototype.FloatMul = FloatMul //  浮点运算乘
Vue.prototype.FloatDiv = FloatDiv // 导入api接口
Vue.prototype.$api = api // 将api挂载到vue的原型上

Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
